import React from 'react';

import ReactDOM from 'react-dom/client';

import App from './App';

const RootWrapper = process.env.REACT_APP_STRICT_MODE === 'false' ? React.Fragment : React.StrictMode;

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <RootWrapper>
        <App />
    </RootWrapper>
);
